































































import { clipboardText } from '@/app/core/utils'
import { add, multiply, reduce, round } from 'lodash'
import { Toast } from 'vant'
import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import { CommissionMixin } from '../commission.mixin'

@Component({
  filters: {
    stepType: (value: number) => {
      const stepList: { [key: number]: string } = {
        1: '推荐分享赚',
        2: '成单分享赚',
        3: '售后分享赚',
        4: '评价分享赚'
      }
      return stepList[value]
    },
    multiply: (value: string) => {
      return multiply(+value, 100)
    },
    timeLabel: (item: any) => {
      return item && (item.barcodeState == 1 ? '核销时间' : item.workState != 40 ? '预产期时间' : '上户时间')
    },
    timeText: (item: any) => {
      return item && (item.barcodeState == 1 ? item.writeoffTime : item.workState != 40 ? item.serviceTime : item.confirmHouseholdTime)
    }
  }
})
export default class MatronComponent extends CommissionMixin {
  @Prop() item!: any
  @Prop() filterStatus!: any

  get empRateTotal() {
    const list = this.item.money
    const sum = reduce(list, (result, value) => {
      const empRate = result.empRate || result
      return add(+empRate, +value.empRate)
    })
    return multiply(round(sum, 2), 100)
  }
  get salerMoneyTotal() {
    const list = this.item.salerDetail
    const sum = reduce(list, (result, value) => {
      const empRate = isNaN(result) ? result.stepSalerMoney * 100 : result
      return add(+empRate, +value.stepSalerMoney * 100)
    })
    return sum.stepSalerMoney || sum / 100
  }

  async copyButtonClick(text: string) {
    try {
      await clipboardText(text)
      Toast('复制成功')
    } catch (e) {
      Toast('复制失败')
    }
  }
}
